module.exports = __webpack_public_path__ + "img/img_hp_banner_disabled.3aee8782.png";